const setActive = (tracks, siteLanguage) => {
  for (var i = 0; i < tracks.length; i++) {
    let trackLanguage = tracks[i].language.substr(0, 2);
    if (trackLanguage) {
      if (trackLanguage === siteLanguage) {
        tracks[i].hasOwnProperty("mode")
          ? (tracks[i].mode = "showing")
          : (tracks[i].enabled = true);
      } else if (tracks[i].hasOwnProperty("mode")) {
        tracks[i].mode = "disabled";
      }
    }
  }
};

const setButtonPause = (btn) => {
  if(btn) {
    btn.classList.toggle("paused");
    btn.setAttribute('aria-label', 'Pause background video');
  }
}

const setButtonPlay = (btn) => {
  if(btn) {
    btn.classList.toggle("paused");
    btn.setAttribute('aria-label', 'Play background video');
  }
}

(() => {
  window.addEventListener("brightcoveloaded", (e) => {
    const selector = '.brightcove_player__video';
    const videos = document.querySelectorAll(selector);
    videos.forEach(video => {
      if (bc) {
        const player = bc(video);

        var btn = null;
        if (video.dataset.pauseButton) {
          btn = document.getElementById(`ac-btn-${video.dataset.videoId}`);
          if (btn) {
            btn.addEventListener('click', (e) => {
              const paused = player.paused();
              if (paused) {
                player.play();
                setButtonPause(btn);
              } else {
                player.pause();
                setButtonPlay(btn);
              }
            })
          }
        }

        player.ready(() => {
          if (video.dataset.audioOnly) {
            player.audioOnlyMode(true);
          }
          if (video.dataset.role) {
            video.setAttribute('role', video.dataset.role);
            video.querySelectorAll('[role]').forEach(e => {
              e.setAttribute('role', video.dataset.role);
            })
          }
        });

        player.on("loadedmetadata", () => {
          if (player.autoplay() && !player.viewability().state.viewable) {
            player.pause();
          }

          let siteLanguage = video.dataset.language || "en-US";
          siteLanguage = siteLanguage.substr(0, 2);

          const audioTracks = player.audioTracks();
          setActive(audioTracks, siteLanguage);

          const textTracks = player.textTracks();
          setActive(textTracks, siteLanguage);
        });

        player.on('viewable-change', (e) => {
          if (e.viewable && player.autoplay()) {
            player.play();
            setButtonPause(btn);
          } else if (player.autoplay()) {
            player.pause();
            setButtonPlay(btn);
          }
        });

      }
    })
  })
})();